import { getErrorMessage } from '@/core/lib/utils/get-error-message'
import { imageResolver } from '@/core/resolvers/image.resolver'
import { IHttpClient } from '@/core/services/http'
import { AxiosError } from 'axios'
import { CityPageResponse } from '../types/api/city-response'
import { CityModel } from '../types/models/city.model'

export function createGetCityDetailsUseCase({
  httpClient,
}: {
  httpClient: IHttpClient
}) {
  return async function (slug: string): Promise<CityModel | null> {
    try {
      const isCitySlug = slug.toLowerCase().includes('airport-taxi')
      if (!isCitySlug) return null

      const response = await httpClient
        .version('v1')
        .get<{ data: CityPageResponse }>(`/website/customer/CityPage/${slug}`)
      return resolver(response.data.data)
    } catch (err) {
      console.log(
        `Error 🚨🚨🚨🚨🚨 Failed to get city ${slug}`,
        getErrorMessage(err),
        err instanceof AxiosError ? err.status : '',
      )

      return null
    }
  }
}

function resolver(city: CityPageResponse): CityModel {
  return {
    metaTitle: city.meta_title,
    metaDescription: city.meta_description,
    hero: {
      ...city.hero,
      image: imageResolver(city.hero.image?.[0]),
    },
    airportTransfer: {
      ...city.airportTransfer,
      image: imageResolver(city.airportTransfer.image?.[0]),
    },
    bookingProcess: {
      ...city.bookingProcess,
      backgroundImage: imageResolver(city.bookingProcess.image?.[0]),
    },
    destinations: {
      ...city.destinations,
      mapImage: imageResolver(city.destinations.image?.[0]),
    },
    experience: {
      ...city.experience,
      image: imageResolver(city.experience.image?.[0]),
    },
    faqs: city.faqs,
    pricing: city.pricing,
  }
}
